import { render, staticRenderFns } from "./activityItem.vue?vue&type=template&id=fbdc3f2a&scoped=true&"
import script from "./activityItem.vue?vue&type=script&lang=js&"
export * from "./activityItem.vue?vue&type=script&lang=js&"
import style0 from "./activityItem.vue?vue&type=style&index=0&id=fbdc3f2a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbdc3f2a",
  null
  
)

export default component.exports